export function MetricCard({ icon: Icon, label, value, unit, color, testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-zinc-900 border border-white/10 p-5 rounded-xl"
    >
      <div className="flex items-center gap-2 mb-3">
        <Icon className={`w-4 h-4 ${color}`} />
        <span className="text-xs uppercase tracking-[0.2em] font-mono text-zinc-400">
          {label}
        </span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-mono font-medium text-white">{value}</span>
        <span className="text-xs font-mono text-zinc-500">{unit}</span>
      </div>
    </div>
  );
}
